/**
 * Persona picker modal (§7g Commit E).
 *
 * Used inside a project view when the user clicks "New Conversation"
 * in the conversations tab. Single-select: click a persona, navigate
 * straight into /projects/:projectId/chat/:personaId (no intermediate
 * confirmation step — the card click is the commitment).
 *
 * PersonaCard already supports a projectId prop that makes clicks
 * route into the project-scoped URL, so we pass it through.
 */

import { useEffect } from "react";
import Modal from "./Modal.jsx";
import PersonaCard from "./PersonaCard.jsx";
import LoadingSkeleton from "./LoadingSkeleton.jsx";
import { useStore } from "../store/useStore.js";

export default function PersonaPickerModal({ open, onClose, projectId, onSelect }) {
  const personas = useStore((s) => s.personas);
  const loading = useStore((s) => s.personasLoading);
  const loadPersonas = useStore((s) => s.loadPersonas);

  useEffect(() => {
    if (open) loadPersonas();
  }, [open, loadPersonas]);

  return (
    <Modal open={open} onClose={onClose} title="Start a conversation" wide>
      <div className="persona-picker">
        {loading && personas.length === 0 ? (
          <div className="persona-picker-grid">
            {Array.from({ length: 6 }).map((_, i) => (
              <LoadingSkeleton key={i} variant="card" />
            ))}
          </div>
        ) : (
          <div className="persona-picker-grid">
            {personas.map((p, i) => (
              <PersonaCard
                key={p.id}
                persona={p}
                projectId={projectId}
                onSelect={onSelect}
                // Focus the first card on modal open so keyboard users
                // land inside the dialog. Modal.jsx no longer
                // force-focuses its close button (that override was
                // defeating form autoFocus in CreateProjectModal);
                // without this explicit focus target, keyboard focus
                // would stay on the trigger button behind the backdrop.
                autoFocus={i === 0}
              />
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
}
